import { render, staticRenderFns } from "./ApplicationRecord.vue?vue&type=template&id=56276b6b"
import script from "./ApplicationRecord.vue?vue&type=script&lang=js"
export * from "./ApplicationRecord.vue?vue&type=script&lang=js"
import style0 from "./ApplicationRecord.vue?vue&type=style&index=0&id=56276b6b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports